import React, { useState, useEffect } from "react";
import {
	TextField,
	Grid,
	MenuItem,
	Button,
	Dialog,
	DialogActions,
	DialogContent
} from "@mui/material";
// import { Card } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";

// import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetCustomerOwnerDetails,
	getCustomerOwnerDetailsList
} from "../../redux/actions/getCustomerOwnerDetailsAction";

import {
	resetCreateFeeWallet,
	createFeeWalletList
} from "../../redux/actions/createFeeWalletAction";

import val from "../../getThemeDetails";
import PhoneInput from "react-phone-input-2";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { Card, FormGroup, Alert } from "reactstrap";
import FormControl from "@mui/material/FormControl";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";


function CreateFeeWallet() {
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [cusid, setCusid] = useState("");
	const [userName, setuserName] = useState("");
	const [firstName, setfirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [gender, setGender] = useState("");
	const [country, setCountry] = useState("");
	const [address, setAddress] = useState("");
	const [city, setCity] = useState("");
	const [mobileNo, setMobileNo] = useState("");
	const [countryCode, setcountryCode] = useState("");
	const [state, setState] = useState("");
	const [postalCode, setpostalCode] = useState("");
	const [dealUsed, setdealUsed] = useState("");
	const [kycAcType, setkycAcType] = useState("");
	const [isActive, setIsActive] = useState("");
	const [currency, setcurrency] = useState("");
	const [isTransacionAllow, setisTransacionAllow] = useState("");
	const [role, setrole] = useState("");

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getCustomerOwnerDetailsRes = useSelector(
		({ getCustomerOwnerDetails }) => getCustomerOwnerDetails
	);

	const createFeeWalletResIs = useSelector(
		({ createFeeWallet }) => createFeeWallet
	);
	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const [getCustomerOwnerDetailsStatus, setgetCustomerOwnerDetailsStatus] =
		useState(false);

	const [createFeeWalletResArray, setcreateFeeWalletResArray] = useState("");
	const [createFeeWalletStatus, setcreateFeeWalletStatus] = useState(false);

	// console.log(createFeeWalletResIs);
	// console.log("createFeeWalletResIs");

	const setgetCustomerOwnerDetailsStatusFunc = () => {
		setgetCustomerOwnerDetailsStatus(true);
		const getCustomerOwnerDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getCustomerOwnerDetailsList(getCustomerOwnerDetailsReq, authToken)
		);
	};

	// useEffect(() => {
	//   setgetCustomerOwnerDetailsStatusFunc();
	// }, []);
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setgetCustomerOwnerDetailsStatusFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "firstName") {
			setfirstName(value);
		}

		if (name === "lastName") {
			setLastName(value);
		}

		if (name === "gender") {
			setGender(value);
		}

		if (name === "address") {
			setAddress(value);
		}

		if (name === "city") {
			setCity(value);
		}

		if (name === "state") {
			setState(value);
		}
		if (name === "postalCode") {
			setpostalCode(value);
		}

		if (name === "dealUsed") {
			setdealUsed(value);
		}

		if (name === "kycAcType") {
			setkycAcType(value);
		}

		if (name === "isActive") {
			setIsActive(value);
		}

		if (name === "isTransacionAllow") {
			setisTransacionAllow(value);
		}
		if ((name = "currency")) {
			setcurrency(value);
		}
	};

	const getCustomerOwnerDetailsStatusFunc = () => {
		if (getCustomerOwnerDetailsStatus) {
			if (getCustomerOwnerDetailsRes.data.status == "Success") {
				setCusid(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.customerId
				);
				setuserName(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.userName
				);
				setfirstName(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.firstName
				);
				setLastName(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.lastName
				);
				setGender(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO.gender
				);
				setCountry(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO.country
				);

				setMobileNo(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO.mobile
				);
				setcountryCode(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.countryCode
				);
				setdealUsed(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.isDealUsed
				);
				setkycAcType(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.kycAccount
				);
				setIsActive(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.isActive
				);
				setcurrency(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.currency
				);
				setisTransacionAllow(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.isTransactionAllowed
				);
				setrole(
					getCustomerOwnerDetailsRes.data.customerMasterDetailsRequestVO
						.userRole
				);
			}
		}
	};

	useEffect(() => {
		getCustomerOwnerDetailsStatusFunc();
	}, [getCustomerOwnerDetailsRes.data.status]);

	const createFeeWalletFun = () => {
		setcreateFeeWalletStatus(true);
		const createFeeWalletReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			customerMasterDetailsRequestVO: {
				customerId: cusid,
				firstName: firstName,
				lastName: lastName,
				gender: gender,
				country: `${country}-${countryCode}`,
				city: city,
				state: state || "",
				registeredPostal: postalCode,
				isDealUsed: dealUsed == "Y" ? "1" : "0",
				kycAccount: kycAcType,
				isActive: isActive,
				isTransactionAllowed: isTransacionAllow,
				currency: currency
			}
		};

		return dispatch(createFeeWalletList(createFeeWalletReq, authToken));
	};

	const createFeeWalletStatusFunc = () => {
		if (createFeeWalletStatus) {
			if (createFeeWalletResIs.data.status == "Success") {
				setNotificationOpen(true);
				setcreateFeeWalletResArray(createFeeWalletResIs.data.status);
			}
			if (createFeeWalletResIs.data.status == "Failed") {
				setNotificationOpen(true);
				setcreateFeeWalletResArray(createFeeWalletResIs.data.status);
				if (
					createFeeWalletResIs.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createFeeWalletResIs.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createFeeWalletResIs.data.status == "failed") {
				setNotificationOpen(true);
				setcreateFeeWalletResArray(createFeeWalletResIs.data.status);
				if (
					createFeeWalletResIs.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createFeeWalletResIs.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		createFeeWalletStatusFunc();
	}, [createFeeWalletResIs.data.status]);

	return (
		<>
			<Layout>
				<Card>
					<BackButton />
					<Grid item xs={12} md={2} lg={2}></Grid>
					<Grid container>
						<Grid item xs={12} md={2} lg={2}></Grid>
						<Grid item xs={12} sm={12} md={8} lg={8}>
							<FormGroup>
								<FormControl fullWidth>
									<TextField
										disabled
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID*"
										type="text"
										fullWidth
										value={cusid || ""}
									/>
								</FormControl>
							</FormGroup>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											disabled
											autoFocus
											margin="dense"
											id="name"
											label="UserName"
											fullWidth
											variant="standard"
											type="text"
											value={userName || ""}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="First Name"
											type="text"
											fullWidth
											variant="standard"
											name="firstName"
											value={firstName || ""}
											onChange={handleChange}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Last Name"
											type="text"
											fullWidth
											variant="standard"
											name="lastName"
											value={lastName || ""}
											onChange={handleChange}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											select
											autoFocus
											margin="dense"
											id="name"
											label="Gender"
											type="text"
											fullWidth
											variant="standard"
											name="gender"
											value={gender || ""}
											onChange={handleChange}
										>
											<MenuItem value="Male">Male</MenuItem>
											<MenuItem value="Female">Female</MenuItem>
										</TextField>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											disabled
											autoFocus
											margin="dense"
											id="name"
											label="Country"
											type="text"
											fullWidth
											variant="standard"
											value={country || ""}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>
							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<PhoneInput
											disabled
											autoFocus
											margin="dense"
											id="name"
											type="text"
											fullWidth
											variant="standard"
											onlyCountries={countryCode}
											value={`${countryCode}-${mobileNo}`}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>

							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Address"
											type="text"
											fullWidth
											variant="standard"
											name="address"
											value={address || ""}
											onChange={handleChange}
										/>
									</FormControl>
								</FormGroup>
							</Grid>
						</Grid>

						<Grid container style={{ marginTop: "4px" }}>
							<Grid item xs={12} md={2} lg={2}></Grid>

							<Grid item xs={12} sm={12} md={8} lg={8}>
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="City"
											type="text"
											fullWidth
											variant="standard"
											name="city"
											value={city || ""}
											onChange={handleChange}
										/>
									</FormControl>
								</FormGroup>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												autoFocus
												margin="dense"
												id="name"
												label="State"
												type="text"
												fullWidth
												variant="standard"
												name="state"
												value={state || ""}
												onChange={handleChange}
											/>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												autoFocus
												margin="dense"
												id="name"
												label="Postal Code"
												type="text"
												fullWidth
												variant="standard"
												name="postalCode"
												value={postalCode || ""}
												onChange={handleChange}
											/>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												autoFocus
												margin="dense"
												id="name"
												label="Deals Used"
												type="text"
												fullWidth
												variant="standard"
												value={dealUsed == "1" ? "Y" : "N"}
												name="dealUsed"
												onChange={handleChange}
											>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												autoFocus
												margin="dense"
												id="name"
												label="KYC Account Type"
												type="text"
												fullWidth
												variant="standard"
												name="kycAcType"
												value={kycAcType || ""}
												onChange={handleChange}
											>
												<MenuItem value="1">BASIC</MenuItem>
												<MenuItem value="2">STANDARD</MenuItem>
												<MenuItem value="3">PREMIUM</MenuItem>
												<MenuItem value="4">SUPREME</MenuItem>
											</TextField>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												autoFocus
												margin="dense"
												id="name"
												label="Is Active"
												type="text"
												fullWidth
												variant="standard"
												name="isActive"
												value={isActive || ""}
												onChange={handleChange}
											>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												autoFocus
												margin="dense"
												id="name"
												label="Is Transaction Allowed"
												fullWidth
												variant="standard"
												name="isTransacionAllow"
												value={isTransacionAllow || ""}
												onChange={handleChange}
											>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>
								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												select
												autoFocus
												margin="dense"
												id="name"
												label="Currency"
												fullWidth
												variant="standard"
												value={currency || ""}
												name="currency"
												onChange={handleChange}
											>
												{adminCurrencyList.success &&
													adminCurrencyList.data.currencyList.map((x) => (
														<MenuItem value={x}>{x}</MenuItem>
													))}
											</TextField>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>

							<Grid container style={{ marginTop: "4px" }}>
								<Grid item xs={12} md={2} lg={2}></Grid>

								<Grid item xs={12} sm={12} md={8} lg={8}>
									<FormGroup>
										<FormControl fullWidth>
											<TextField
												disabled
												autoFocus
												margin="dense"
												id="name"
												label="Role"
												type="text"
												fullWidth
												variant="standard"
												value={role || ""}
											/>
										</FormControl>
									</FormGroup>
								</Grid>
							</Grid>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px",
							display: "flex",
							justifyContent: "center"
						}}
					>
						<Grid item>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={createFeeWalletFun}
							>
								Create
							</Button>
						</Grid>
						{/* <Grid item md={7}></Grid> */}
					</Grid>
				</Card>{" "}
			</Layout>

			{createFeeWalletResArray.toLowerCase() == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Record Udated SuccessFully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createFeeWalletResArray.toLowerCase() == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								Update Record Failed{" "}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createFeeWalletResArray.toLowerCase() == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								Update Record Failed{" "}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default CreateFeeWallet;
